module.exports = __webpack_public_path__ + "img/thai-teledentistry-logo.434e38f9.png";